/* global __webpack_modules__ */

import { appDefault } from '../../config/config';
import filtersModule from '../../filters/filters';

let filterSwitch = null;

if (__webpack_modules__[require.resolveWeak('angular')]) {
  filterSwitch = angular
    .injector(['ng', filtersModule])
    .get('filterSwitchFilter');
} else {
  filterSwitch = filtersModule('filterSwitch');
}

/**
 * getDataRankings function
 * @TODO finish building this out
 * @param  {[type]} api       [description]
 * @param  {[type]} sortColumn [description]
 * @param  {[type]} sortHeader [description]
 * @return {[type]}            [description]
 */
export default function(api, sortColumn, sortHeader) {
  const groupRankArray = [];
  const wrapupsArray = [];
  let accountForWrapup = false;
  let currItem;

  // Switch to using the event `afterSortChanged`
  return api.rowModel.rowsToDisplay.map((row) => {
    const formatted = filterSwitch(row.data[sortColumn], sortHeader);
    const isWrapup = appDefault
      .specialWrapups
      .indexOf(row.data.Location) >= 0;

    if (!isWrapup) {
      groupRankArray.push(currItem !== formatted ? 0 : 1);
      wrapupsArray.push(0);
    } else {
      groupRankArray.push(1);
      wrapupsArray.push(1);
    }

    const groupRankSubset = groupRankArray
      .slice(0, row.childIndex + 1);

    const tieRank = groupRankSubset
      .reduce((acc, curr) =>
        acc + curr,
      0);

    const tieRankRowAdjust = groupRankSubset
      .slice(0, groupRankSubset.lastIndexOf(0))
      .reduce((acc, curr) =>
        acc + curr,
      0);

    accountForWrapup = accountForWrapup ? true :
      tieRank === tieRankRowAdjust && wrapupsArray.indexOf(1) > -1;

    const wrapupAdjust = accountForWrapup ?
      wrapupsArray.slice(0, row.childIndex + 1)
        .reduce((acc, curr) => acc + curr, 0) : 0;

    currItem = isWrapup ? currItem : formatted;

    return row.childIndex + 1 -
      tieRank + tieRankRowAdjust - wrapupAdjust;
  });
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/table/getDataRankings.js